import type React from 'react';

type FlagType = FlagAppearance;

type FlagAppearance = 'error' | 'info' | 'normal' | 'success' | 'warning';

export const FEEDBACK_COLLECTOR_SUCCESS_FLAG_ID = 'feedbackSent';

interface FlagLink {
	text: string;
	href?: string;
	to?: string;
	target?: string;
}

export interface Flag {
	id: number | string;
	title?: string | React.ReactNode;
	description?: string | React.ReactNode;
	type?: FlagType;
	links?: FlagLink[];
	appearance?: FlagAppearance;
	actions?: {
		content: React.ReactNode;
		onClick?: () => void;
		href?: string;
		target?: string;
	}[];
	icon?: JSX.Element;
}
